import { AppRoutes } from "AppRoutes";
import { PropsWithChildren } from "react";
import { matchRoutes, useLocation } from "react-router";

import { ParamsContext } from "./ParamsContext";

const routes = [
  { path: AppRoutes.Board },
  { path: AppRoutes.BoardSettings },
  { path: AppRoutes.Run },
  { path: AppRoutes.VotingDetail },
  { path: AppRoutes.VoteRedirect },
  { path: AppRoutes.RunRedirect },
];

export const ParamsProvider: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const location = useLocation();

  const matches = matchRoutes(routes, location);
  const params = matches?.[0]?.params ?? {};

  let boardId = (params as Record<string, string>).boardId || undefined;
  if (boardId === "all" || boardId === "my") {
    boardId = undefined;
  }

  let runId = (params as Record<string, string>).runId || undefined;

  return <ParamsContext.Provider value={{ boardId, runId }}>{children}</ParamsContext.Provider>;
};
